(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["offer-section"] && !Shopify.designMode) return;
  try {
    
  // Nieuwjaarsaanbieding JavaScript
class NewYearOffer {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.container = document.getElementById(sectionId);
    
    if (!this.container) return;
    
    this.settings = this.getSettings();
    this.init();
  }
  
  getSettings() {
    // Haal data attributes op van de sectie
    const confettiEnabled = this.container.dataset.confettiEnabled === 'true';
    const confettiCount = parseInt(this.container.dataset.confettiCount) || 40;
    const glowEnabled = this.container.dataset.glowEnabled === 'true';
    
    return {
      confettiEnabled,
      confettiCount,
      glowEnabled
    };
  }
  
  init() {
    // Pas glow effect toe indien ingeschakeld
    if (this.settings.glowEnabled) {
      const headline = this.container.querySelector(`.section-${this.container.dataset.sectionId}-main-headline`);
      if (headline) {
        headline.classList.add(`section-${this.container.dataset.sectionId}-glow-effect`);
      }
    }
    
    // Genereer confetti indien ingeschakeld
    if (this.settings.confettiEnabled) {
      this.createConfetti();
    }
  }
  
  createConfetti() {
    const confettiCount = this.settings.confettiCount;
    const sectionId = this.container.dataset.sectionId;
    
    for (let i = 0; i < confettiCount; i++) {
      const confetti = document.createElement('div');
      confetti.classList.add(`section-${sectionId}-confetti`);
      
      // Willekeurige positie
      confetti.style.left = Math.random() * 100 + '%';
      
      // Willekeurige animatieduur en vertraging
      const duration = Math.random() * 5 + 5;
      confetti.style.animationDuration = duration + 's';
      confetti.style.animationDelay = Math.random() * 5 + 's';
      
      // Willekeurige animatierichting
      confetti.style.animationTimingFunction = `cubic-bezier(${Math.random()}, ${Math.random()}, ${Math.random()}, ${Math.random()})`;
      
      this.container.appendChild(confetti);
    }
  }
}

// Initialiseer wanneer de DOM geladen is
document.addEventListener('DOMContentLoaded', function() {
  // Vind alle nieuwjaarsaanbieding secties
  const offerSections = document.querySelectorAll('[id^="newyearOffer-"]');
  
  offerSections.forEach(section => {
    new NewYearOffer(section.id);
  });
});

// Initialiseer ook wanneer nieuwe secties worden geladen (voor live preview)
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
    if (sectionElement) {
      const offerContainer = sectionElement.querySelector('[id^="newyearOffer-"]');
      if (offerContainer) {
        new NewYearOffer(offerContainer.id);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
